import React from "react";
import styled, { css } from "styled-components";

// #region SCOPED CSS
const StyledHeader = styled.header`
    && {
        box-sizing: border-box;
        height: 48px;
        min-height: 48px;
        max-height: 48px;
        flex: 0 0 48px;
        min-width: 0;
        max-width: 100%;
        display: flex;
        align-items: center;
        column-gap: 16px;
        padding: 0 24px;
        border-bottom: 1px solid #34393a;
        background: linear-gradient(90deg, #211f1b 0%, #191b1b 28%, #151718 68%, #101213 100%);
        overflow: hidden;
    }

    && > .premium-card-header-title {
        margin: 0;
        padding: 0;
        min-width: 0;
        flex: 1 1 auto;
        font-family: inherit;
        font-size: 14px;
        font-weight: 400;
        font-style: normal;
        letter-spacing: 0;
        line-height: 1.2;
        color: #fff4e3;
        text-transform: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .premium-card-header-right {
        display: flex;
        align-items: center;
        margin-left: auto;
        min-width: 0;
        max-width: 60%;
        max-height: 100%;
        overflow: hidden;
    }

    .premium-card-header-adornment { display: flex; align-items: center; min-width: 0; }

    ${({ $wrap }) => $wrap && css`
        && {
            height: auto; max-height: none; flex: 0 0 auto;
            flex-wrap: wrap; row-gap: 8px; padding-top: 8px; padding-bottom: 8px;
            overflow: visible;
        }
        .premium-card-header-right {
            max-width: 100%; max-height: none; overflow: visible;
            flex-wrap: wrap;
        }
        .premium-card-header-adornment { max-width: 100%; flex-wrap: wrap; }
    `}

    @media (max-width: 600px) {
        && { padding: 0 16px; }
    }
    ${({ $wrap }) => $wrap && css`
        @media (max-width: 600px) { && { padding-top: 8px; padding-bottom: 8px; } }
    `}
`;
// #endregion

/**
 * Sales Intel premium header, without application dependencies.
 * @param {Object} props
 * @param {string} props.title Required card title.
 * @param {"h1"|"h2"|"h3"} [props.headingLevel="h2"] Semantic heading level.
 * @param {string} [props.titleId] ID for the heading, usable by aria-labelledby.
 * @param {React.ReactNode} [props.rightContent] Optional legend or other header content.
 * @param {React.ReactNode} [props.afterTitleComponent] Content adjacent to the title.
 * @param {boolean} [props.wrap=false] Allow multi-row content without clipping.
 * @param {string} [props.className] Class applied to the header.
 */
export default function CardHeader({ title, headingLevel = "h2", titleId, rightContent, className, afterTitleComponent, wrap = false }) {
    const Heading = ["h1", "h2", "h3"].includes(headingLevel) ? headingLevel : "h2";

    return (
        <StyledHeader className={className} $wrap={wrap}>
            <Heading className="premium-card-header-title" id={titleId}>{title}</Heading>
            {afterTitleComponent != null && <div className="premium-card-header-adornment">{afterTitleComponent}</div>}
            {rightContent != null && <div className="premium-card-header-right">{rightContent}</div>}
        </StyledHeader>
    );
}
